import watermark from './watermark-dom.js'

// 增加水印
function watermarkInit () {
  let param = {
    watermark_txt: '',
    watermark_x: 20, // 水印起始位置x轴坐标
    watermark_y: 20, // 水印起始位置Y轴坐标
    watermark_rows: 0, // 水印行数
    watermark_cols: 0, // 水印列数
    watermark_x_space: 0, // 水印x轴间隔
    watermark_y_space: 0, // 水印y轴间隔
    watermark_font: '微软雅黑', // 水印字体
    watermark_color: 'black', // 水印字体颜色
    watermark_fontsize: '18px', // 水印字体大小
    watermark_alpha: 0.05, // 水印透明度，要求设置在大于等于0.003
    watermark_width: 166, // 水印宽度
    watermark_height: 120, // 水印长度
    watermark_angle: 30 // 水印倾斜度数
  }
  param.watermark_txt = window.userInfo?.uid ? `${window.userInfo.username || '唯品会会员'}\n${window.userInfo.uid}` : '唯品会保密信息，\n未经允许不得扩散'
  watermark.init(param)

}

function showWatermark () {
  console.log('showWatermark')
  let el = document.getElementById('wm_div_id')
  el && (el.style.display = 'block')
  watermark.addResizeEvent()
}

function hideWatermark () {
  console.log('hideWatermark')
  let el = document.getElementById('wm_div_id')
  el && (el.style.display = 'none')
  watermark.removeResizeEvent()
}

window.$watermark = {
  init: watermarkInit,
  hide: hideWatermark,
  show: showWatermark
}

window.$watermark.init()
// window.promiseAbort && window.promiseAbort.abort()
// window.promiseAbort = getSessionInfo()
// window.promiseAbort.then(() => {
  
// })

window.addEventListener('message', function (e) {
  let fn = e.data
  if (fn === 'hideWatermark') window.$watermark.hide()
  if (fn === 'showWatermark') window.$watermark.show()
})
